
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/track",
      function () {
        return require("private-next-pages/track.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/track"])
      });
    }
  